import { Link } from "react-router-dom";
import { InquiryCTA } from "../components/PlanEventModal";
import { PageMeta } from "../components/PageMeta";
import { GoldTrophy } from "../components/GoldTrophy";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="relative isolate flex min-h-[70vh] items-center overflow-hidden bg-white">
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10" style={{ background: "linear-gradient(to bottom, #fff 0%, #fff 60%, rgba(20,155,158,0.08) 75%, rgba(20,155,158,0.35) 100%)" }} />
      <PageMeta title="Page Not Found" />
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8">
        <GoldTrophy className="trophy-bounce mb-6 h-14 w-14 lg:hidden" data-testid="not-found-trophy" />
        <img src="/images/brand-trophy-confetti.jpg" alt="" aria-hidden width="1024" height="1024" className="trophy-bounce pointer-events-none absolute right-[6%] top-1/2 hidden w-[320px] -translate-y-1/2 mix-blend-multiply lg:block" />
        <p className="eyebrow mb-4">404</p>
        <h1 data-testid="not-found-title" className="buzzer-shake font-display text-4xl sm:text-5xl lg:text-6xl">Wrong answer. <span className="text-en-teal">That page doesn't exist.</span></h1>
        <p className="mt-6 max-w-xl text-black/70">The link may be broken or the page may have moved. Let's get you back in the game.</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" data-testid="not-found-home-btn" className="btn-primary">Back to Home</Link>
          <InquiryCTA label="Contact Us" data-testid="not-found-plan-event-btn" className="btn-outline" />
        </div>
      </div>
    </section>
  );
}
